import { device } from 'constants/media-query'
import styled from 'styled-components'

export const StyledFamilyAndFriendsContainer = styled.div`
  :not(:first-child) {
    margin-bottom: 16px;
  }
  overflow: hidden;
`

export const StyledFamilyAndFriendsSection = styled.section`
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: start;
`

export const StyledTabContentTitle = styled.h1`
  font-size: 20px;
  font-weight: 500;
  margin: 0 8px 25px 0;
  @media ${device.desktop} {
    margin-bottom: 32px;
  }
`

export const StyledFamilyAndFriendsCardsSections = styled.div`
  display: flex;
  flex-direction: column;
  margin-inline: 0;
  width: 100%;
  margin-bottom: 20px;

  .swiper-button-prev,
  .swiper-button-next {
    transform: translateY(-50%);
  }
  .swiper-ltr {
    .swiper-button-next,
    .swiper-button-prev {
      transform: rotate(180deg) translateY(-50%);
    }
  }
`

export const StyledFamilyAndFriendsMiniTitle = styled.h2`
  margin-top: 0;
  margin-bottom: 24px;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
`

export const StyledSwiperContainer = styled.section`
  border-radius: 4px;
`
